module.exports = __webpack_public_path__ + "images/icons/ic-signature-20-4785d4b80377913bb1e8151b5cd945af.png";